import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { GradingPeriodDTO } from '@app/infrastructure/models/grading-period';
import { IStudentListSortDTO } from '@app/infrastructure/models/student';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-grading-period-selector-presentation',
  templateUrl: './grading-period-selector-presentation.component.html',
  styleUrls: ['./grading-period-selector-presentation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GradingPeriodSelectorPresentationComponent {
  @Input() gradingPeriods = [];
  @Input() link: string;
  @Output() selectionEvent: EventEmitter<IStudentListSortDTO> =
    new EventEmitter<IStudentListSortDTO>();

  propagateSelection(value: IStudentListSortDTO) {
    this.selectionEvent.emit(value);
  }
}
